<template>
  <div class="mapContainer">
    <div id="ol_map" class="ol_map"></div>
    <ThermodynamicScale :type="tab" class="thermodynamic_scale" v-if="dvMapVisible" />
    <Tabs v-model="tab" class="tabs" v-if="dvMapVisible" />
    <WarningFilter v-model="weatherWarnings" class="warning-filter" />
    <RegionIntroDialog :value="regionIntro" v-if="regionCode" @close="unselectRegion" class="region-intro-dialog" ref="RegionIntroDialog" />
    <!-- <WarningFlag :list="warnings['115.23856782, 35.57247783']" class="warning-flag" /> -->
    <div class="debug" v-show="false">
      <div>进度与热力可见 dvMapVisible: {{ dvMapVisible }}</div>
      <div>季度类型 season: {{ season }}</div>
      <div>选中的区块 regionCode: {{ regionCode }}</div>
      <div>热力图/进度图 tab: {{ tab }}</div>
      <div>农机品目 vehicleModel: {{ vehicleModel }}</div>
      <div>预警类型 weatherWarnings: {{ weatherWarnings.filter((v) => v.selected).map((v) => v.label) }}</div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { TileSuperMapRest, LayerStatus, SetLayerStatusParameters, LayerInfoService } from '@supermap/iclient-ol';
import Map from 'ol/Map';
import { Tile as TileLayer } from 'ol/layer';
import { XYZ } from 'ol/source';
import View from 'ol/View';
import Feature from 'ol/Feature';
import Overlay from 'ol/Overlay';
import Point from 'ol/geom/Point';
import LineString from 'ol/geom/LineString';
import Polygon from 'ol/geom/Polygon';
import MultiPolygon from 'ol/geom/MultiPolygon';
import { defaults as defaultControls } from 'ol/control';
import { Style, Icon, Stroke, Fill, Text } from 'ol/style';
import VectorSource from 'ol/source/Vector';
import Cluster from 'ol/source/Cluster';
import { Vector as VectorLayer } from 'ol/layer';
import GeoJSON from 'ol/format/GeoJSON.js';
import { VERSION as OlVersion } from 'ol/util';
import { defaults as defaultInteractions } from 'ol/interaction';
import { groupedWarnings as GroupedWarningsApi, warnings as WarningsApi, heatmap as HeatmapApi, getAreaLonAndLat as AreaLonAndLatApi } from './api';
import GIS_MAP from '@/assets/JSON/gisMap';
import Tabs from './components/tabs.vue';
import ThermodynamicScale from './components/thermodynamicScale.vue';
import WarningFilter from './components/warningFilter.vue';
import RegionIntroDialog from './components/regionIntroDialog.vue';
import WarningFlag from './components/warningFlag.vue';
import { MapStyles, GET_FEATURE_AREACODE, GET_FEATURE_CENTROID, GetColorFromLinner, DV_VEHICLE_MODEL_CODES } from './constants';

// 预警类型：收割热力:thermodynamic, 收割进度:progression
const WARN_TYPE = {
  thermodynamic: 1,
  progression: 2,
};

// 收割热力:thermodynamic, 收割进度:progression
// 收获类机械 // machineryType 农机品类 0全部 1收获类机械 2播种类机械 3插秧类机械 4耕整类机械 5植保类机械 6收获后处理机械 7其他机械
// const DV_VEHICLE_MODEL_CODES = ['1'];

export default {
  name: 'mapContainer',
  components: {
    ThermodynamicScale,
    Tabs,
    WarningFilter,
    RegionIntroDialog,
    // WarningFlag,
  },
  props: {
    // 当前选中的农机品目，「收获类机械」时有很多特殊处理
    vehicleModel: {
      type: [String, Number],
      default: null,
    },
    // 是否可拖动或缩放地图
    dragable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      tab: 'thermodynamic', // 收割热力:thermodynamic, 收割进度:progression
      regionCode: null, // 当前选中的行政区
      // 热力图数值
      heatmapData: {
        // 收割热力图
        thermodynamic: [
          { areaId: '410928101', value: 0.1 },
          { areaId: '410928102', value: 0.2 },
          { areaId: '410928103', value: 0.3 },
          { areaId: '410928104', value: 0.4 },
          { areaId: '410928207', value: 0.5 },
          { areaId: '410928206', value: 0.6 },
          { areaId: '410928107', value: 0.7 },
          { areaId: '410928108', value: 0.8 },
          { areaId: '410928109', value: 0.9 },
          { areaId: '410928110', value: 1.0 },
        ],
        // 收割进度图
        progression: [
          { areaId: '410928100', value: 0.1 },
          { areaId: '410928101', value: 0.2 },
          { areaId: '410928102', value: 0.3 },
          { areaId: '410928103', value: 0.4 },
          { areaId: '410928104', value: 0.5 },
          { areaId: '410928106', value: 0.6 },
          { areaId: '410928107', value: 0.7 },
          { areaId: '410928108', value: 0.8 },
          { areaId: '410928109', value: 0.9 },
          { areaId: '410928110', value: 1.0 },
          { areaId: '410928111', value: 0.1 },
          { areaId: '410928112', value: 0.2 },
          { areaId: '410928202', value: 0.3 },
          { areaId: '410928206', value: 0.4 },
          { areaId: '410928207', value: 0.5 },
          { areaId: '410928208', value: 0.6 },
          { areaId: '410928211', value: 0.7 },
          { areaId: '410928212', value: 0.8 },
          { areaId: '410928213', value: 0.9 },
          { areaId: '410928214', value: 1.0 },
          { areaId: '410902362', value: 0.1 },
        ],
      },
      // 接口返回的预警数据 { type: '收割热力:thermodynamic,收割进度:progression,天气weather'}
      // 警告：dataId 是当前记录是唯一标识，且已用于数据查询，不可换名！！
      warnings: {
        // // prettier-ignore
        // '115.19551082, 35.70710377': [
        //   { dataId: '1111', type: 'thermodynamic', level: 1 },
        //   { dataId: '4444', type: 'progression', level: 2 },
        //   { dataId: '5555', type: 'weather', level: '003', category: '0008' },
        //   { dataId: '6666', type: 'weather', level: '002', category: '0026' },
        // ],
        // '115.23856782, 35.57247783': [
        //   { dataId: '2222', type: 'weather', level: '001', category: '0006' },
        //   { dataId: '3333', type: 'thermodynamic', level: 3 },
        //   { dataId: '4444', type: 'progression', level: 2 },
        //   { dataId: '5555', type: 'weather', level: '003', category: '0008' },
        //   { dataId: '6666', type: 'weather', level: '002', category: '0026' },
        // ],
        // '115.02448082, 35.48546187': [
        //   { dataId: '7777', type: 'weather', level: '002', category: '0026' },
        //   { dataId: '8888', type: 'thermodynamic', level: 1 },
        //   { dataId: '9999', type: 'progression', level: 2 },
        // ],
        // // prettier-ignore
        // '115.12127682, 35.51828785': [
        //   { dataId: '1010', type: 'progression', level: 1 },
        //   { dataId: '8888', type: 'thermodynamic', level: 1 },
        //   { dataId: '4444', type: 'progression', level: 2 },
        //   { dataId: '5555', type: 'weather', level: '001', category: '0020' },
        //   { dataId: '5555', type: 'weather', level: '003', category: '0008' },
        //   { dataId: '6666', type: 'weather', level: '002', category: '0026' },
        // ],
        // // prettier-ignore
        // '115.25335982, 35.47217787': [
        //   { dataId: '1212', type: 'weather', level: '002', category: '0026' },
        // ],
      },
      // 预警类型下拉及选中状态
      weatherWarnings: [
        // 预警类型 { type: '收割热力:thermodynamic,收割进度:progression,天气weather'}
        // 格式参数：
        // { label: '台风预警', category: '0000', level: '001', type: 'thermodynamic', selected: 1, disabled: 0, count: 11 },
        // { label: '暴雨预警', category: '0000', level: '001', type: 'progression', selected: 1, disabled: 0, count: 22 },
        // { label: '高温预警', category: '0003', level: '001', type: 'weather', selected: 1, disabled: 0, count: 33 },
        // { label: '寒潮预警', category: '0004', level: '001', type: 'weather', selected: 0, disabled: 1, count: 44 },
        // { label: '大雾预警', category: '0005', level: '001', type: 'weather', selected: 1, disabled: 0, count: 55 },
        // { label: '暴雪预警', category: '0006', level: '001', type: 'weather', selected: 1, disabled: 0, count: 66 },
        // { label: '大风预警', category: '0007', level: '001', type: 'weather', selected: 1, disabled: 0, count: 77 },
        // { label: '沙尘预警', category: '0008', level: '001', type: 'weather', selected: 1, disabled: 0, count: 88 },
        // { label: '冰雹预警', category: '0009', level: '001', type: 'weather', selected: 1, disabled: 0, count: 99 },
        // { label: '干旱预警', category: '0010', level: '001', type: 'weather', selected: 1, disabled: 0, count: 10 },
      ],
      layers: {
        baseLayer: null, // "底图"
        boundaryLayer: null, // 行政边界块
        regionNameLayer: null, // 行政区名称
        countyLayer: null, // 乡镇边界网（里边的区块可加颜色以用于展示热力图）
      },
      mapCenter: [115.16, 35.55], // 地图中心点
      mapZoom: 11.0, // 地图层级
    };
  },
  computed: {
    ...mapGetters(['season', 'getactiveRegionObj', 'getMachineryType']),
    currentAreaCode() {
      let self = this;
      const area = self.getactiveRegionObj || {};
      const code = area.areaCode;
      return code;
    },
    // 可以使用「收割热力图、收割进度图」的农机分类code
    dvMapVisible() {
      let self = this;
      let visible = DV_VEHICLE_MODEL_CODES.includes(self.vehicleModel);
      return visible;
    },
    // 点击地图后弹出的某个行政区划的收割概要
    regionIntro() {
      let self = this;
      let intro = self.heatmapData[self.tab].find((v) => v.areaId == self.regionCode) || {};
      if (self.tab == 'thermodynamic') {
        intro._labelAlign = 'center'; // def: left
      }
      return intro;
      // const intro1 = self.heatmapData['thermodynamic'].find((v) => v.areaId == self.regionCode) || { attrs: [] };
      // const intro2 = self.heatmapData['progression'].find((v) => v.areaId == self.regionCode) || { attrs: [] };
      // const intro = {
      //   areaName: intro1.areaName == intro2.areaName ? intro1.areaName : `${intro1.areaName ?? '--'} / ${intro2.areaName ?? '--'}`,
      //   date: intro1.date == intro2.date ? intro1.date : `${intro1.date ?? '--'} / ${intro2.date ?? '--'}`,
      //   attrs: [...intro1.attrs, ...intro2.attrs],
      // };
      // return intro;
    },
  },
  watch: {
    tab: {
      handler(v) {
        let self = this;
        self.getWarnings();
        self.getGroupedWarnings(); // 预警项类型下拉
        self.setThermodynamicAreas(); // 更新地图上的热力图
        // 取消某个行政区块的选中状态并恢复为默认状态
        self.unselectRegion();
      },
      immediate: true,
    },
    // 收割热力图、收割进度图相关数据在地图上是否可见
    dvMapVisible: {
      handler(v) {
        let self = this;
        if (!v) {
          // 隐藏地图中的热力图和进度图数据
          self.unselectRegionFeatures();
          // 取消某个行政区块的选中状态并恢复为默认状态
          self.unselectRegion();
        } else {
          self.setThermodynamicAreas(); // 更新地图上的热力图
        }
      },
      immediate: false, // 不要改为 true, true 时地图没加载好的话……
    },
    // 农机品类下拉的当前 code 值
    vehicleModel: {
      handler(v) {
        let self = this;
        self.getGroupedWarnings(); // 预警项类型下拉
        self.getHeatmapData(); // 地图上的热力图数据
      },
      immediate: true,
    },
    // 选中的预警项变动时
    weatherWarnings: {
      handler(v) {
        let self = this;
        self.setWarningIcons();
      },
      immediate: false,
    },
  },
  methods: {
    // 获取 预警项类型下拉
    getGroupedWarnings() {
      let self = this;
      typeof self.GroupedWarnings_cancel === 'function' && self.GroupedWarnings_cancel(); // 取消上一个请求以用参数重新获取
      const params = {
        warnType: WARN_TYPE[self.tab],
      };
      const promise = GroupedWarningsApi(params);
      self.GroupedWarnings_cancel = promise.cancel || (() => {});
      promise
        .then((res) => {
          console.log('预警类型下拉.res', res);
          self.weatherWarnings = res || [];
        })
        .catch((res) => {
          console.log('预警类型下拉.err', res);
          self.statistic = [];
        });
    },
    // 获取 预警项类型下拉
    getHeatmapData() {
      let self = this;
      typeof self.Heatmap_cancel === 'function' && self.Heatmap_cancel(); // 取消上一个请求以用参数重新获取
      const params = { season: self.season };
      const promise = HeatmapApi(params);
      self.Heatmap_cancel = promise.cancel || (() => {});
      promise
        .then((res) => {
          console.log('%c热力图.res', 'color:#CC0', JSON.parse(JSON.stringify(res)));
          self.heatmapData = res || { thermodynamic: [], progression: [] };
          self.setThermodynamicAreas(); // 更新地图上的热力图
        })
        .catch((res) => {
          console.log('热力图.err', res);
          self.statistic = { thermodynamic: [], progression: [] };
        });
    },
    // 获取地图上的预警
    getWarnings() {
      let self = this;
      typeof self.getWarnings_cancel === 'function' && self.getWarnings_cancel(); // 取消上一个请求以用参数重新获取
      const params = {
        warnType: WARN_TYPE[self.tab],
      };
      const promise = WarningsApi(params);
      self.getWarnings_cancel = promise.cancel || (() => {});
      promise
        .then((res) => {
          console.log('%c地图上的预警.res', 'color:#cc0', res);
          self.warnings = res || {};
          self.setWarningIcons(); // 预警图标
        })
        .catch((res) => {
          console.log('地图上的预警.err', res);
          self.statistic = {};
        });
    },
    // 显示预警详情
    showWarningDetail(item) {
      console.log('showWarningDetail', item);
      let self = this;
      self.$emit('warning', { type: item.type, id: item.dataId });
    },
    // 在地图上绘制热力图颜色块
    setThermodynamicAreas() {
      let self = this;
      const layer = self.layers.boundaryLayer;
      if (!layer) {
        console.warn('在地图上绘制热力图颜色块[setThermodynamicAreas].fail', { layer });
        return;
      }
      const source = layer.getSource();
      const features = source && source.getFeatures();
      // console.groupCollapsed('设置热力图颜色量', features && features.length);
      // console.log(`热力数据 ${self.tab}`, JSON.parse(JSON.stringify(self.heatmapData[self.tab])));
      features &&
        features.forEach((f) => {
          self.setRegionFeature2ItsWorkingStyle(f);
        });
      // console.log('setThermodynamicAreas', { features, source });
      // console.groupEnd();
    },
    // 在地图上显示预警图标
    setWarningIcons() {
      let self = this;
      // 先清除已有的预警图标
      self.clearWarningIcons();
      // 挑选出用户选中的预警事件
      const selectedWarnings = (function (groupedWarnings, selectedGroup) {
        const data = {};
        for (const lnglat in groupedWarnings) {
          if (Object.prototype.hasOwnProperty.call(groupedWarnings, lnglat)) {
            const list = groupedWarnings[lnglat].filter((v) => selectedGroup.some((g) => g.type == v.type && g.category == v.category));
            if (list.length > 0) {
              data[lnglat] = list;
            }
          }
        }
        return data;
      })(
        self.warnings, // {lnglat:[],}
        self.weatherWarnings.filter((v) => v.selected).map((v) => ({ type: v.type, category: v.category }))
      );
      // 增加
      let warningIcons = [];
      const Content = Vue.extend(WarningFlag);
      for (const lnglat in selectedWarnings) {
        if (Object.prototype.hasOwnProperty.call(selectedWarnings, lnglat)) {
          const warnings = selectedWarnings[lnglat];
          const type = [...new Set(warnings.map((v) => v.type))].join(',');
          let element = new Content({
            propsData: {
              list: warnings,
              clickCallback: self.showWarningDetail,
              selectedCallback: (e) => {
                self.blurWarningOverlays(e);
                self.unselectRegion();
              },
              // vm: self,
            },
          }).$mount();
          const position = lnglat.split(/,\s*/);
          const icon = new Overlay({
            position,
            element: element.$el,
            offset: [0, 10],
            stopEvent: true,
          });
          icon.set('type', type);
          icon.set('_key', lnglat);
          icon.set('_instance', element); // 用于调用内部方法来清除选中状态
          icon.setPositioning('bottom-center');
          icon.getElement().parentNode.style.zIndex = 1001;
          warningIcons.push(icon);
        }
      }
      // console.groupCollapsed('在地图上显示预警图标', warningIcons.length);
      if (warningIcons.length > 0) {
        warningIcons.forEach((icon, i) => {
          self.map.addOverlay(icon);
          // console.log('add', i, icon);
        });
      }
      // console.groupEnd();
    },
    // 清除地图上的所有预警图标(或指定 type 的图标)
    // type: warnings.map((v) => v.type))].join(',')，例： 'thermodynamic,progression,weather'
    clearWarningIcons(type) {
      let self = this;
      // console.groupCollapsed('清除所有预警图标', { type });
      const overlays = self.map.getOverlays().getArray();
      overlays.slice().forEach((overlay, i) => {
        const t = overlay.get('type') || '';
        const reg = new RegExp(`\b${type}\b`, 'g');
        if (!type || reg.test(t)) {
          // console.log('remove:', i, t, overlay);
          self.map.removeOverlay(overlay);
        }
      });
      // console.groupEnd();
    },
    // 清除其它预警Overlays的选中状态 event:{active: 当前点击的预警图标是否展开, target: 当前点击的预警图标}
    blurWarningOverlays(event = null) {
      // console.groupCollapsed('清除其它预警Overlays的选中状态', event);
      let self = this;
      const { target: ignore } = event || {};
      const targetOverlayKey = (function (warningItem) {
        let key = null;
        if (!warningItem) {
          return key;
        }
        for (const k in self.warnings) {
          if (Object.prototype.hasOwnProperty.call(self.warnings, k)) {
            const list = self.warnings[k];
            for (let i = 0; i < list.length; i++) {
              const w = list[i];
              if (w.key == warningItem.key) {
                key = k;
                return key;
              }
            }
          }
        }
        return key;
      })(ignore);
      const overlays = self.map.getOverlays().getArray();
      overlays.slice().forEach((overlay, i) => {
        // 折叠其它 Overlay
        const key = overlay.get('_key');
        if (key != targetOverlayKey) {
          overlay.get('_instance').blur();
          overlay.getElement().parentNode.style.zIndex = 1001;
        } else {
          overlay.getElement().parentNode.style.zIndex = 1002;
        }
      });
      // console.groupEnd();
      // 隐藏区域概要
      if (event && event.active) {
        self.regionCode = null;
      }
    },
    // 在地图上显示行政区划的艺术字版本的名称
    setTownshipNames() {
      let self = this;
      // console.groupCollapsed('在地图上显示行政区划的艺术字版本的名称');
      const layer = self.layers.boundaryLayer;
      if (!layer) {
        console.warn('setTownshipNames.fail', { layer });
        return;
      }
      const features = layer.getSource().getFeatures();
      const SetPosition = (coordinates) => {
        const nameFeatures = [];
        features.forEach((f) => {
          const areaName = f.get('name') || f.get('乡镇级');
          const areaId = GET_FEATURE_AREACODE(f);
          const point = coordinates.find((v) => v.areaId == areaId);
          // 找到 feature 的坐标信息后，设置到 feature 的 geometry 中
          if (point) {
            let imgPath = null;
            try {
              imgPath = require(`./images/areaName/${areaName}.png`);
            } catch (e) {
              console.warn(`加载行政区名称图片失败`, e);
            }
            if (imgPath) {
              // console.info(`行政区`, { areaName, imgPath: imgPath && imgPath.slice(0, 32) + '...', point });
              const nameFeature = new Feature({
                geometry: new Point([point.lon, point.lat]),
                name: areaName,
              });
              nameFeature.setStyle(
                new Style({
                  // https://openlayers.org/en/latest/apidoc/module-ol_style_Icon-Icon.html
                  image: new Icon({
                    src: imgPath,
                    scale: 0.75,
                    // anchor: [1, 1], // def:[0.5,0.5]
                    // displacement: [0, 0],
                  }),
                })
              );
              nameFeature.set('areaId', areaId);
              nameFeatures.push(nameFeature);
              // console.log(`行政区名称图片已添加`, { areaName, areaId, point, imgPath });
            } else {
              console.warn(`找不到行政区名称图片: ${areaName}`);
            }
          } else {
            console.warn('找不到中心点', { areaName, areaId, point });
          }
        });
        // console.log('艺术字版本的行政区划名称.nameFeatures', nameFeatures);
        self.layers.regionNameLayer.getSource().addFeatures(nameFeatures);
      };
      const planB = () => {
        // 1. 使用 geoJSON 中的 feature 的 geometry 中的坐标信息
        const coordinates = features.map((f) => {
          const areaName = f.get('name') || f.get('乡镇级');
          const areaId = GET_FEATURE_AREACODE(f);
          const centroid = GET_FEATURE_CENTROID(f);
          let position = {
            areaName,
            areaId,
            lon: centroid[0],
            lat: centroid[1],
          };
          return position;
        });
        SetPosition(coordinates);
        console.log('%c在地图上显示行政区划的艺术字版本的名称(使用 geoJSON 中的 feature 的 geometry 中的坐标信息)', 'color:#C0C', coordinates);
      };
      // 2. 使用后端接口获取行政区划的坐标信息
      AreaLonAndLatApi(self.currentAreaCode)
        .then((res) => {
          console.log('%c在地图上显示行政区划的艺术字版本的名称.res', 'color:#CC0', self.currentAreaCode, res);
          let coordinates = (res || []).map((v) => ({
            ...v,
            // areaName: v.areaName && v.areaName.replace(/^濮阳县/, ''),
            areaName: v.areaName ?? `未命名地区`,
          }));
          SetPosition(coordinates);
        })
        .catch((res) => {
          console.warn('在地图上显示行政区划的艺术字版本的名称.err', self.currentAreaCode, res);
          planB();
        });
      // console.groupEnd();
    },
    // 高亮所选行政区的名字并blur其它行政区的名字
    toggleFocusTownshipName(areaId, focus = null) {
      let self = this;
      // console.log('toggleFocusTownshipName', { areaId, focus });
      const layer = self.layers.regionNameLayer;
      if (!layer) {
        console.warn('toggleFocusTownshipName.fail', { layer });
        return;
      }
      const focusStyle = (f) =>
        new Style({
          image: new Icon({
            src: f.getStyle().getImage().getSrc(),
            scale: 1,
          }),
        });
      const blurStyle = (f) =>
        new Style({
          image: new Icon({
            src: f.getStyle().getImage().getSrc(),
            scale: 0.75,
          }),
        });
      const features = layer.getSource().getFeatures();
      features.forEach((f) => {
        const adcode = f.get('areaId');
        if (areaId && adcode == areaId) {
          const style = focus ? focusStyle(f) : blurStyle(f);
          f.setStyle(style);
        } else {
          f.setStyle(blurStyle(f));
        }
      });
    },
    // 选中行政区并显示概要
    showRegionIntro(feature, position) {
      // console.log('选中行政区并显示概要');
      let self = this;
      if (!self.dvMapVisible) {
        return;
      }
      if (!feature) {
        // console.warn('showRegionIntro.fail', { feature });
        return;
      }
      // 切换当前块的选中状态
      const selected = feature.get('selected');
      // focus or blur current feature and blur other features
      if (selected) {
        self.setRegionFeature2ItsWorkingStyle(feature);
        feature.set('selected', false);
        self.regionCode = null;
      } else {
        feature.setStyle(MapStyles.region.active);
        feature.set('selected', true);
        self.regionCode = feature.get('adcode');
        // 设置概要的坐标
        self.$nextTick(() => {
          self.$refs.RegionIntroDialog.setPosition(position);
        });
      }
      self.toggleFocusTownshipName(feature.get('adcode'), !selected);
      // 去除其它块的选中状态
      self.unselectRegionFeatures(feature);
      // 隐藏预警overlays
      self.blurWarningOverlays();
      // 行政区划的名称
    },
    // 取消某个行政区块的选中状态并恢复为默认状态
    unselectRegion() {
      let self = this;
      self.regionCode = null;
      self.unselectRegionFeatures();
      self.toggleFocusTownshipName();
    },
    // 取消选中
    unselectRegionFeatures(ignoreFeature = null) {
      let self = this;
      const layer = self.layers.boundaryLayer;
      if (!layer) {
        console.warn('unselectRegionFeatures.fail', { layer });
        return;
      }
      layer
        .getSource()
        .getFeatures()
        .forEach((f) => {
          if (!ignoreFeature || f.get('adcode') != ignoreFeature.get('adcode')) {
            self.setRegionFeature2ItsWorkingStyle(f);
            f.set('selected', false);
          }
        });
    },
    // 还原地图中心点及缩放值
    goCenterPoint() {
      let self = this;
      console.log('回中心点', { center: self.mapCenter, zoom: self.mapZoom });
      self.map.getView().setCenter(self.mapCenter);
      self.map.getView().setZoom(self.mapZoom);
      // 这个方法似乎也可以实现当前方法需要的功能：
      // self.resetMapView();
    },
    // 将行政区的样式设置为它该显示的样式（有热力数据时显示及热力颜色）
    setRegionFeature2ItsWorkingStyle(feature) {
      let self = this;
      const f = feature;
      const list = self.dvMapVisible ? self.heatmapData[self.tab] : [];
      // const list = self.list || [];
      const properties = f.getProperties();
      const areaId = GET_FEATURE_AREACODE(f);
      const config = list.find((v) => v.areaId == areaId);
      if (config) {
        const value = config.value || 0;
        const color = GetColorFromLinner(value);
        const style = new Style({
          fill: new Fill({
            color,
          }),
        });
        f.setStyle(style);
        // console.log('%c行政区的热力数据.found', `color:${color}`, { value, color, properties, town: properties.乡镇级 });
      } else {
        f.setStyle(MapStyles.region.default);
        // console.log('行政区的热力数据.notFound', { areaId, town: properties.乡镇级, data: JSON.parse(JSON.stringify(list)) });
      }
    },
    //
    initBaseLayer() {
      let self = this;
      self.map = new Map({
        target: 'ol_map',
        layers: [
          new TileLayer({
            source: new XYZ({
              // url: 'http://wprd0{1-4}.is.autonavi.com/appmaptile?x={x}&y={y}&z={z}&lang=zh_cn&size=1&scl=1&style=6'
              url: 'https://t{0-7}.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TileCol={x}&TileRow={y}&TileMatrix={z}&tk=1d109683f4d84198e37a38c442d68311',
            }),
            isGroup: true,
            name: '高德图路网',
          }),
          // // 全国的地区名称
          // new TileLayer({
          //   zIndex: 10,
          //   source: new TileSuperMapRest({
          //     url: 'http://gis-server.chiaic.com/iserver/services/map-QuanGuoXingZhengQuHuaShuJu/rest/maps/全国矢量数据',
          //     cacheEnabled: false,
          //   }),
          //   isGroup: true,
          //   name: '全国省矢量',
          //   type: 'baseLyer',
          // }),
        ],
        controls: defaultControls({
          attribution: false,
        }),
        view: new View({
          center: self.mapCenter,
          zoom: self.mapZoom,
          projection: 'EPSG:4326',
          maxZoom: 14,
          minZoom: 10,
        }),
        // 禁用拖动和缩放交互
        interactions: !self.dragable
          ? defaultInteractions({
              dragPan: false,
              pinchZoom: false,
              mouseWheelZoom: false,
              keyboardZoom: false,
              shiftDragZoom: false,
              doubleClickZoom: false,
            })
          : undefined,
      });
      // 某县的底图
      self.layers.baseLayer = new TileLayer({
        source: new TileSuperMapRest({
          url: 'https://gis-server.chiaic.com/iserver/services/map-AIDaPing/rest/maps/濮阳县_AI大屏_地图',
          cacheEnabled: false,
        }),
        isGroup: true,
        zIndex: 0,
        name: '高清影像图',
        type: 'baseLyer',
      });
      self.map.addLayer(self.layers.baseLayer);

      // 某县的区划边界网
      self.layers.countyLayer = new TileLayer({
        source: new TileSuperMapRest({
          url: 'https://gis-server.chiaic.com/iserver/services/map-AIDaPing/rest/maps/濮阳县_AI大屏_边界',
          cacheEnabled: false,
        }),
        properties: {
          clickable: false, // 设置图层不可点击
        },
        isGroup: true,
        zIndex: 1,
        name: '乡镇边界',
        type: 'baseLyer',
      });
      self.map.addLayer(self.layers.countyLayer);

      // 艺术字版的行政区名称
      self.layers.regionNameLayer = new VectorLayer({
        // declutter: false, // 发生碰撞时清理掉与其重叠的 feature（不能实现避让）
        zIndex: 2,
        source: new VectorSource(),
        properties: {
          clickable: false, // 设置图层不可点击
        },
      });
      self.map.addLayer(self.layers.regionNameLayer);

      // 下级行政区划块们 濮阳县410928
      self.layers.boundaryLayer = new VectorLayer({
        source: new VectorSource({
          features: new GeoJSON().readFeatures(GIS_MAP[self.currentAreaCode].geoJSON),
        }),
        name: '行政区划',
      });
      self.layers.boundaryLayer
        .getSource()
        .getFeatures()
        .forEach((f) => {
          f.setStyle(MapStyles.boundaryDefault); // 重置地图自带的默认样式
        });
      self.map.addLayer(self.layers.boundaryLayer);
      self.setTownshipNames();

      // 交互
      self.map.on('addlayer', function (e) {
        console.log('%caddlayer', 'backgroundColor:#CC0;', e.layer.get('name'), e);
      });
      self.map.on('singleclick', (e) => {
        const pixel = self.map.getEventPixel(e.originalEvent);
        const currentFeature = self.map.forEachFeatureAtPixel(pixel, function (feature, layer) {
          // 只允许点击行政边界块中的 feature，忽略其它 layer 的 feature
          if (layer != self.layers.boundaryLayer) {
            return null;
          }
          return feature;
        });
        const adcode = currentFeature && currentFeature.get('adcode');
        // console.log('singleclick', { adcode, feature: currentFeature });

        if (adcode) {
          const features = self.layers.boundaryLayer.getSource().getFeatures() || [];
          const regionFeature = features.find((v) => v.get('adcode') == adcode);
          if (regionFeature) {
            self.showRegionIntro(regionFeature, pixel);
          }
        }

        // // 机手
        // if (featureList.length === 1 && featureList[0].values_._userId) {
        //   self.$emit('userPointClick', featureList[0].values_);
        //   return;
        // }
        // if (currentFeature && currentFeature.get('features')) {
        //   if (featureList.length === 1 && featureList[0].values_._vehicleId) {
        //     console.log('currentFeature>>', featureList[0].values_);
        //     self.$emit('vehiclePointClick', featureList[0].values_);
        //   } else {
        //     self.resetMapView();
        //   }
        // }
      });
      // 监听hover
      self.map.on('pointermove', (e) => {
        // console.log('pointermove');
        // var pixel = self.map.getEventPixel(e.originalEvent);
        // var currentFeature = self.map.forEachFeatureAtPixel(pixel, function (feature, layer) {
        //   return feature;
        // });
        // if (currentFeature && currentFeature.values_ && currentFeature.values_.feature_type == '乡镇统计点') {
        //   let info = {
        //     x: e.originalEvent.x,
        //     y: e.originalEvent.y,
        //     ...currentFeature.values_,
        //   };
        //   self.$emit('townshipPoint', true, info);
        // } else {
        //   self.$emit('townshipPoint', false);
        // }
      });
      self.checkZoom(self.map.getView().getZoom());
      self.map.getView().on('change:resolution', () => {
        const zoom = self.map.getView().getZoom();
        // console.log('map.zoom', zoom);
        self.checkZoom(zoom);
      });
      self.map.on('moveend', (e) => {
        // console.log('map.moveend', e);
        // 将 RegionIntroDialog 移动到新的位置
        if (self.regionCode) {
          console.groupCollapsed('moveend.移动RegionIntroDialog到新位置');
          console.log('regionCode', self.regionCode);
          const feature = self.layers.boundaryLayer
            .getSource()
            .getFeatures()
            .find((f) => f.get('adcode') == self.regionCode);
          console.log('feature', feature);
          if (feature) {
            const extent = feature.getGeometry().getExtent();
            const centerCoordinate = [(extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2];
            const position = self.map.getPixelFromCoordinate(centerCoordinate);
            self.$refs.RegionIntroDialog.setPosition(position);
            // console.log({ centerCoordinate, position });
          }
          console.groupEnd();
        }
      });
      console.log('%c OpenLayers ', 'background-color:#00a9fe;color:#FFF', `inited, v${OlVersion}`);
    },
    /** 重置试图层级、中心点 */
    resetMapView() {
      if (this.map.getView().getZoom() != this.mapZoom || JSON.stringify(this.map.getView().getCenter()) != JSON.stringify(this.mapCenter)) {
        // 重置层级
        this.map.getView().setZoom(this.mapZoom);
        // 重置中心
        this.map.getView().setCenter(this.mapCenter);
      }
    },
    /** 地图层级变更 */
    checkZoom(zoom) {},
  },
  mounted() {
    let self = this;
    self.initBaseLayer();
    // self.getWarnings(); // 预警图标
  },
};
</script>
<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}

@function vh($px) {
  @return ($px / 1080) * 100vh;
}

.mapContainer {
  width: 100%;
  height: 100%;

  .ol_map {
    width: 100%;
    height: 100%;
  }

  .thermodynamic_scale {
    position: absolute;
    right: vw(500);
    bottom: vh(120);
  }

  .tabs {
    position: absolute;
    left: vw(485);
    bottom: vh(120);
  }

  .warning-filter {
    position: absolute;
    left: vw(557);
    top: vh(26);
  }

  .region-intro-dialog {
    position: absolute;
    z-index: 1000;
    left: vw(457);
    top: vh(550);
  }

  .debug {
    pointer-events: none;
    position: fixed;
    left: 450px;
    bottom: 360px;
    background-color: #ff000094;
    color: #fff;
    padding: 10px;
    border-radius: 4px;
  }
  // .warning-flag {
  //   position: fixed;
  //   left: 550px;
  //   top: 600px;
  // }
}
</style>
